import React from "react";

import {
	FormControlLabel,
	Radio,
	RadioGroup,
} from "@mui/material";

import {
	Controller,
	UseFormReturn,
} from "react-hook-form";

import {
	RadioDefaultProps,
} from "./models";
import { t } from "@lingui/macro";

export class RadioDefault extends React.Component<RadioDefaultProps & UseFormReturn, {}>
{
	render()
	{
		return (<Controller
			name={this.props.name}
			control={this.props.control}
			defaultValue={this.props.defaultValue ?? true}
			render={({field}) => (<RadioGroup
				{...field}
				row
				sx={{color: "#FFFFFF"}}>
        <FormControlLabel
					value={true}
					control={<Radio size="small" sx={{color: "#FFFFFF"}} />}
					label={t({
            id: "df-true-radio",
            message: "Si"
          })}
					onClick={() => (this.props.updateValue(true))}/>
        <FormControlLabel
					value={false}
					control={<Radio size="small" sx={{color: "#FFFFFF"}} />}
					label={t({
            id: "df-false-redio",
            message: "No"
          })}
					onClick={() => (this.props.updateValue(false))}/>
			</RadioGroup>)}
		/>);
	}
}
